<template>
<EntityReport entity="ReportPositions" />
</template>

<script>
export default {

}
</script>
